import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-contactDepartment-lookup',
  templateUrl: './micro-contactDepartment-lookup.component.html'
})
export class MicroContactDepartmentLookupComponent  {

  @Input()
  contactDepartmentId:any;

  @Input()
  link:boolean = true;
}
